import styled from 'styled-components'
import { Image } from 'react-bootstrap'

const Container = styled.div`
  display: block;
  border: 1px solid
    ${(props) => (props.active ? 'var(--main-color)' : '#f0f0f0')};
  color: ${(props) => props.active && 'var(--main-color)'};
  margin: 0 10px;
  padding: 10px;
  border-radius: 6px;
  cursor: pointer;
  text-align: center;
`
const ImageContainer = styled.div`
  height: 200px;
  position: relative;
  margin-top: 15px;

  img {
    max-height: 100%;
    max-width: 100%;
    width: auto;
    height: auto;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }
`
const Title = styled.div`
  height: 55px;
`

const Slide = ({ device, handleClick, selected }) => (
  <Container active={selected} onClick={handleClick.bind(null, device)}>
    <Title>
      <div>{device.manufacturer}</div>
      <div>{device.name}</div>
    </Title>
    {device.image_location && (
      <ImageContainer>
        <Image
          alt="device"
          src={`https://s3.amazonaws.com/tpassets.devicebits.com${device.image_location}`}
          responsive
        />
      </ImageContainer>
    )}
  </Container>
)

export default Slide
